import { startsWith } from 'lodash';

export const addTextPrefix = (text: string, prefix?: string) => {
  if (!prefix) return text;
  return startsWith(text, prefix) ? text : prefix + text;
};
